<template>
    <div>
        <app-dlg
                v-if="shownRelay"
                :show-dlg.sync="shownRelay"
                :title="statusMap.match || 'New Status Map'"
                :dlg-width="700"
                :default-padding="false"
                :show-loading="showLoading"
        >
            <template>
                <app-divider label="Classification Options"></app-divider>
                <div class="px-4 d-flex align-center">
<!--                    <v-text-field-->
<!--                            label="Alias"-->
<!--                            color="primary"-->
<!--                            placeholder="eg. GMail"-->
<!--                            hide-details="auto"-->
<!--                            v-model="editMap.alias"-->
<!--                            outlined-->
<!--                            dense-->
<!--                            class="pt-3 pr-2 flex-grow-1 flex-equal"-->
<!--                    ></v-text-field>-->
                    <v-autocomplete
                            dense
                            outlined
                            :items="labels"
                            label="Label"
                            hide-details="true"
                            class="pt-3 pl-2 flex-grow-1 flex-equal"
                            item-text="text"
                            item-value="id"
                            v-model="editMap.defaultLabel"
                    >
                        <template v-slot:selection="{item}">
                            <v-icon :color="item.color" left>{{item.icon}}</v-icon> {{item.text}}
                        </template>
                    </v-autocomplete>
                </div>

                <app-divider label="Team Rules" :show-search="!!editMap.teamLabels.length" :search.sync="teamsFilterString" class="pt-4">
                    <template v-slot:action>
                        <v-tooltip top>
                            <template v-slot:activator="{on}">
                                <v-btn
                                        dark
                                        color="primary"
                                        icon
                                        v-on="on"
                                        @click="teamsShowAdd = true"
                                >
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            Add Team Rule
                        </v-tooltip>
                    </template>
                </app-divider>

<!--Teams-->
                <div v-if="!editMap.teamLabels.length" class="overline grey--text text-center pb-4">
                    No Team Rules
                </div>
                <div v-else>
                    <v-list dense style="max-height: 400px;" class="of-y">
                        <v-list-item
                                v-for="teamLabel in filteredTeamLabels"
                                :key="teamLabel.teamId"
                                @click="() => {}"
                        >
                            <v-list-item-avatar>
                                <v-icon :color="labelsRef[teamLabel.label].color">{{labelsRef[teamLabel.label].icon}}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="teamsRef[teamLabel.teamId].name"/>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-autocomplete
                                        flat
                                        dense
                                        solo
                                        :items="labels"
                                        hide-details="true"
                                        class="pl-2 flex-grow-1 flex-equal"
                                        item-text="text"
                                        item-value="id"
                                        v-model="teamLabel.label"
                                        @input="teamsChanged = true;"
                                ></v-autocomplete>
                            </v-list-item-action>
                            <v-list-item-action>
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                icon
                                                color="error"
                                                v-on="on"
                                                @click="teamLabelsRemove(teamLabel)"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    Remove Team Rule
                                </v-tooltip>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </div>
            </template>

            <template v-slot:actions>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="shownRelay = false"
                        outlined
                        size="small"
                        :disabled="showLoading"
                >
                    Cancel
                </v-btn>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="saveChanges"
                        size="small"
                        :loading="showLoading"
                        :disabled="showLoading"
                >
                    Save Changes
                </v-btn>
            </template>
        </app-dlg>
<!--Add Teams-->
        <app-dlg
                v-if="teamsShowAdd"
                :show-dlg.sync="teamsShowAdd"
                title="Add Team Rules"
                :default-padding="false"
        >

            <app-list
                    v-model="teamsAddSelectedTeams"
                    :items="availableTeams"
                    :multiple="true"
                    headline-key="name"
                    item-key="_id"
                    :show-check-boxes="true"
                    :return-object="false"
                    class="fill-height of-y"
                    :height="400"
            />

            <template v-slot:actions>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="teamsShowAdd = false"
                        outlined
                        size="small"
                >
                    Cancel
                </v-btn>

                <v-btn
                        @click="teamsAddRules"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                >
                    Add
                </v-btn>
            </template>
        </app-dlg>

<!--Classification Confirmation-->
        <app-classification-dlg ref="classificationDlg" @future="saveChangesConfirm()" @history="saveChangesConfirm(true)"/>
    </div>
</template>

<script>
import {StatusMap} from "@/models/statusMap";
import AppDlg from "@/components/Shared/AppDlg";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import {mapGetters} from "vuex";
import AppList from "@/components/Shared/AppList/AppList";
import {arrSplice, nameSort} from "@/core/codeFunctions";
import AppClassificationDlg from "@/components/Shared/AppClassificationDlg";

export default {
    components: {AppClassificationDlg, AppList, AppDivider, AppDlg},
    props: {
        statusMap: StatusMap,
        shown: Boolean,
    },
    data() {
        return {
            editMap: new StatusMap({}),
            showLoading: false,

            teamsFilterString: null,
            teamsShowAdd: false,
            teamsAddSelectedTeams: [],
            teamsAdding: false,
            teamsChanged: false,
        }
    },
    watch: {
        statusMap: {
            immediate: true,
            handler(val) {
                this.editMap = new StatusMap(val ? JSON.parse(JSON.stringify(val)) : {});
                this.teamsChanged = false
            }
        },
        teamsShowAdd(val) {
            if (val) {
                this.teamsAddSelectedTeams = [];
            }
        }
    },
    methods: {

        async saveChangesConfirm(updateHistorical = false) {
            try {
                this.showLoading = true;
                const {_id} = await this.editMap.upsert(updateHistorical);
                const addedSiteMap = await this.statusmaps.once(_id)
                this.$emit('input', addedSiteMap)
                this.showLoading = false
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
                this.showLoading = false;
            }
        },

        saveChanges() {
            // Check If Big Modification is Necessary
            if (this.editMap.defaultLabel !== this.statusMap.defaultLabel || this.teamsChanged) {
                if (this.$store.state.historyPreference)
                    return this.saveChangesConfirm(this.$store.state.historyPreference === 'history')
                else {
                    return this.$refs.classificationDlg.showDlg();
                }
            }
            this.saveChangesConfirm();
        },

        teamLabelsRemove(teamLabel) {
            arrSplice(this.editMap.teamLabels, obj => obj === teamLabel)
            this.teamsChanged = true;
        },

        teamsAddRules() {
            this.teamsAddSelectedTeams.forEach(teamId => {
                this.editMap.teamLabels.push({
                    teamId,
                    label: 0
                })
            })
            this.teamsChanged = true;
            this.teamsShowAdd = false;
        }
    },
    computed: {
        ...mapGetters(['labelsRef', 'labels', 'teams', 'teamsRef', 'statusmaps']),
        filteredTeamLabels() {
            return this.editMap.teamLabels
                    .filter(teamLabel => {
                        if (!this.teamsFilterString)
                            return true
                        return (this.teamsRef[teamLabel.teamId].name || '').toLowerCase().includes((this.teamsFilterString || '').toLowerCase())
                    })
                    .sort((a,b) => this.teamsRef[a.teamId].name > this.teamsRef[b.teamId].name ? 1 : -1)
        },
        availableTeams() {
            const addedTeams = this.editMap.teamLabels.map(teamLabel => teamLabel.teamId)
            return this.teams.filter(team => !addedTeams.includes(team._id)).sort(nameSort)
        },
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        }
    },
}
</script>

<style scoped>

</style>